import { render } from "./PostLogoutView.vue?vue&type=template&id=7d9df6c2"
import script from "./PostLogoutView.vue?vue&type=script&lang=js"
export * from "./PostLogoutView.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__